const notAllowedDomains = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com",
  "outlook.com",
  "live.com",
  "msn.com",
  "icloud.com",
  "yogirt.com",
  "pm.me",
  "techie.com",
  "emailbbox.pro",
  "w3fax.com",
  "rfcdrive.com",
]

// Based on dual-use goods export sanctions
// from EU:
// https://www.sanctionsmap.eu/#/main
const blockedTLDs = [
  "by", // Belarus
  "ir", // Iran
  "kp", // North Korea
  "mm", // Myanmar / Burma
  "ru", // Russian Federation
]

export const isEmailDomainForbidden = (event: { email: string }) => {
  const emailDomain = event.email.split("@")[1] || ""
  const dotSplit = emailDomain.split(".")
  const tld = dotSplit[dotSplit.length - 1] ?? ""
  return notAllowedDomains.includes(emailDomain.toLowerCase()) || blockedTLDs.includes(tld.toLowerCase())
}
